export type Environment = 'development' | 'acceptance' | 'production';

/**
 * Configuration the embedding host supplies at mount time.
 *
 * Studio ships as a single build artifact that serves development, acceptance
 * and production (one image — see `packages/console-app/Dockerfile`), so these
 * values cannot be injected at build time. They have so far been derived from
 * `window.location.hostname`, which only holds while Studio is served from its
 * own origin: once it runs inside the portal page the hostname is the
 * customer's portal and every environment looks like production.
 *
 * Every field is optional. With nothing supplied the hostname-derived
 * fallbacks still apply, which is what the iframe deployment relies on.
 */
export type HostConfig = {
    environment?: Environment;
    /**
     * Real server path Studio is mounted on, e.g. `/studio`. Normalised by
     * `normalizeBasePath`; `/` means Studio owns the root. Feeds react-router's
     * `basename` and every absolute in-app URL we build.
     */
    basePath?: string;
};

let hostConfig: HostConfig = {};

/**
 * Replaces the host configuration. Called once, before the app renders, so that
 * module-scope readers (`getEnvironment`, `envVar`) see it on their first call.
 */
export const setHostConfig = (config: HostConfig): void => {
    hostConfig = config;
};

export const getHostConfig = (): Readonly<HostConfig> => hostConfig;
